<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="recommendCode"
    >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.recommendStatus === 'Y' ? 'success' : 'info'"
        >
          {{ row.recommendStatusName }}
        </el-tag>
      </template>

      <template v-slot:modiinfo="{ row }">
        <span>修改人: {{ row.modifyByName }}</span>
        <br />
        <span>修改日期: {{ row.modifyDate }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad('detail', row.recommendCode)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="fromLoad('edit', row.recommendCode)"
              v-if="allow('M')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>

    <!--项目选择弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="60%"
    >
      <project-list ref="form" @success="saveSuccess"></project-list>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l("INDEX.btn_cancel") || "取 消"
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l("INDEX.btn_save") || "保 存" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {
    ProjectList: () => import("./project"),
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => {
            this.$emit("submit");
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: "seq",
          width: 50,
          fixed: "left",
          align: "center",
          type: "seq",
        },
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          headerAlign: "center",
          align: "center",
          fixed: "right",
          width: 80,
          slots: {
            default: "opt",
          },
        },
        {
          field: "recommendNo",
          width: 180,
          title: this.$l("table_label_recommend_no") || "推荐单号",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "recommendTitle",
          minWidth: 180,
          title: this.$l("table_label_recommend_title") || "推荐标题",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "custName",
          width: 180,
          title: this.$l("table_label_customer") || "客户名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "prjTitle",
          width: 180,
          title: this.$l("table_label_project_title") || "项目名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "recommendStatusName",
          width: 80,
          title: this.$l("table_label_status") || "推荐单状态",
          align: "center",
          slots: { default: "status" },
        },
        {
          field: "endDate",
          width: 150,
          title: this.$l("table_label_end_date") || "结束日期",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "modifyInfo",
          minWidth: 250,
          title: this.$l("table_label_modifyInfo") || "修改信息",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
          slots: { default: "modiinfo" },
        },
      ],
    };
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = "") {
      if (ref === "add") {
        this.formOption.title = "项目列表";
        setTimeout(() => {
          // 调用组件表单加载方法
          this.$refs.form.clearCurrent();
        }, 0);
        this.formOption.dialogFormVisible = true;
        return;
      }
      this.$router.push({
        name: "personal-my-recommend-detail",
        params: {
          type: ref,
          recommendCode: val,
        },
      });
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$router.push({
        name: "personal-my-recommend-detail",
        params: {
          type: "add",
          recommendCode: "1",
        },
      });
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
  },
};
</script>
